import React, {useState, useEffect} from 'react';
import FirmwareWizardChoose from './FirmwareWizardChoose';
import FirmwareWizardGeneralAvailability from './FirmwareWizardGeneralAvailability';
import SMCModal from '../../../components/core/SMCModal';
import {useTranslation} from 'react-i18next';
import FirmwareWizardCustomerHotfix from './FirmwareWizardCustomerHotfix';

function FirmwareWizard({
    isOpen,
    onRequestClose,
    onSuccess
}) {
    const { t } = useTranslation();
    const [wizardStep, setWizardStep] = useState('CHOOSE');

    const wizardVars = {}

    let WizardBody = null;

    useEffect(() => {
        setWizardStep('CHOOSE');
    }, [isOpen]);

    switch (wizardStep) {
        case 'CHOOSE':
            WizardBody = FirmwareWizardChoose;
            break;
        case 'GA':
            WizardBody = FirmwareWizardGeneralAvailability;
            break;
        case 'HF':
            WizardBody = FirmwareWizardCustomerHotfix;
            break;
        default:
            onRequestClose();
            break;
    }

    return (
        <SMCModal
            title={t('SMC_FIRMWIZ_TITLE')}
            isOpen={isOpen}
            onRequestClose={onRequestClose}
            width={850}
            height={755}
        >
            <WizardBody
                onCancel={onRequestClose}
                onFinish={onSuccess}
                setWizardStep={setWizardStep}
                wizardVars={wizardVars}
            />
        </SMCModal>
    );
}

export default FirmwareWizard;